(function(){
  if (window.__alvaPdpEssentialsFast) return;
  window.__alvaPdpEssentialsFast = true;
  /* Moved from snippets/alva-pdp-benefits.liquid (Oct 8 2026). The glass-lid flow used to be
     switched on by Liquid; the snippet now passes it as data-alva-lid on this script tag. */
  var HAS_LID = !!(document.currentScript && document.currentScript.getAttribute('data-alva-lid') === 'true');

  /* Pre-claim the retired observer-heavy copies that used to live in this snippet. */
  window.__alvaAccIcons = true;
  window.__alvaLidTiles = true;
  window.__alvaAtcLabel = true;
  window.__alvaDotFill = true;
  window.__alvaLidThumbs = true;

  /* CURRENCY SAFETY — 16 Sep 2026. Copy the server-rendered price string
     verbatim; never regex or reformat it. `.alva-price-row__price` holds an
     <span class="sr-only"> accessible label followed by the money text node,
     so the label is removed structurally. See snippets/alva-money.liquid. */
  function alvaCleanPrice(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('.sr-only, .visually-hidden'), function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  var singleBaselines = Object.create(null);
  function updateUpgradeCosts(info) {
    var picker = info.querySelector('.alva-pan-selector');
    if (!picker) return;
    var key = picker.getAttribute('handle') || '';
    var checked = picker.querySelector('input[data-alva-single]:checked');
    var singles = Array.prototype.slice.call(picker.querySelectorAll('input[data-alva-single]'));
    if (checked) singleBaselines[key] = checked.value;
    var baseline = singleBaselines[key];
    if (!singles.some(function(input){ return input.value === baseline; })) {
      var preferred = singles.find(function(input){ return input.dataset.alvaLabel === '11-inch'; }) || singles[0];
      baseline = preferred && preferred.value;
      singleBaselines[key] = baseline;
    }
    var baselineInput = singles.find(function(input){ return input.value === baseline; });
    var baselineLabel = picker.querySelector('[data-alva-upgrade-baseline]');
    if (baselineLabel && baselineInput) baselineLabel.textContent = 'vs ' + baselineInput.dataset.alvaLabel;
    picker.querySelectorAll('[data-alva-upgrade-from]').forEach(function(line) {
      line.hidden = line.dataset.alvaUpgradeFrom !== baseline;
    });
  }
  /* Remember the last single size before the native variant picker rerenders. */
  window.addEventListener('change', function(event) {
    var input = event.target;
    var picker = input.closest && input.closest('.alva-pan-selector');
    if (!picker || !input.matches('input[data-alva-single]')) return;
    singleBaselines[picker.getAttribute('handle') || ''] = input.value;
    var info = picker.closest('.product-info');
    if (info) updateUpgradeCosts(info);
  }, true);

  function setAtc(){
    var root = document.querySelector('.shopify-section--main-product');
    var info = root && root.querySelector('.product-info');
    if (!info) return;
    updateUpgradeCosts(info);
    var btn = info.querySelector('.buy-buttons button');
    if (!btn) return;
    var target = btn.querySelector('[data-alva-atc-label]') || btn.querySelector('span') || btn;
    var canLabel = /^add\b/i.test((target.textContent || '').trim());
    var priceEl = info.querySelector('.alva-price-row__price');
    var row = priceEl && priceEl.closest('.alva-price-row');
    var price = row && row.dataset.alvaBaseMoney || alvaCleanPrice(priceEl);
    var cents = row && row.hasAttribute('data-alva-base-cents') ? Number(row.dataset.alvaBaseCents) : NaN;
    var lid = info.querySelector('[data-alva-lid-toggle]');
    var lp = lid && lid.querySelector('[data-alva-lid-total]');
    var withLid = !!(window.__alvaLidWant && lp && row && lid.dataset.alvaPanVariant === row.dataset.alvaPriceVariant);
    if (withLid) {
      price = lp.dataset.alvaLidTotal;
      cents = Number(lp.dataset.alvaLidTotalCents);
    }
    if (!price || !/\d/.test(price)) return;
    function setMoney(element) {
      if (!element || alvaCleanPrice(element) === price) return;
      var label = element.querySelector('.sr-only');
      element.replaceChildren();
      if (label) element.appendChild(label);
      element.appendChild(document.createTextNode(price));
    }
    var compareEl = info.querySelector('.alva-price-row__compare');
    var percentEl = info.querySelector('.alva-price-row__pct');
    if (compareEl) {
      if (!compareEl.hasAttribute('data-alva-original-money')) compareEl.dataset.alvaOriginalMoney = alvaCleanPrice(compareEl);
      var compareMoney = withLid ? lp.dataset.alvaLidCompare : compareEl.dataset.alvaOriginalMoney;
      if (compareMoney) {
        var compareLabel = compareEl.querySelector('.sr-only');
        compareEl.replaceChildren();
        if (compareLabel) compareEl.appendChild(compareLabel);
        compareEl.appendChild(document.createTextNode(compareMoney));
      }
      if (percentEl) {
        if (!percentEl.hasAttribute('data-alva-original-text')) percentEl.dataset.alvaOriginalText = percentEl.textContent;
        var compareCents = withLid && Number(lp.dataset.alvaLidCompareCents);
        percentEl.textContent = compareCents > cents ? '(' + Math.round((compareCents - cents) / compareCents * 100) + '% off)' : percentEl.dataset.alvaOriginalText;
      }
    }
    var configuration = info.querySelector('[data-alva-configuration] p');
    if (configuration) {
      if (!configuration.hasAttribute('data-alva-original-text')) configuration.dataset.alvaOriginalText = configuration.textContent;
      configuration.textContent = withLid ? configuration.dataset.alvaOriginalText.replace('Lids not included.', 'Matching lids added for every pan.') : configuration.dataset.alvaOriginalText;
    }
    setMoney(priceEl);
    // Apply holiday pricing once to the base selected configuration, including paid lids.
    var holiday = info.querySelector('alva-holiday-price');
    if (holiday && Date.now() < Date.parse(holiday.dataset.end) && Number.isFinite(cents)) {
      var holidayRate = cents >= 40000 ? 25 : cents >= 25000 ? 20 : cents >= 10000 ? 15 : 0;
      cents = cents - Math.round(cents * holidayRate / 100);
      price = new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents / 100);
    }
    if (Number.isFinite(cents) && cents >= 0) {
      var amount = String(cents / 100);
      var root = info.closest('.shopify-section--main-product');
      if (root) root.querySelectorAll('square-placement[data-platform="shopify-app-blocks"], afterpay-placement').forEach(function(placement) {
        if (placement.getAttribute('data-amount') !== amount) placement.setAttribute('data-amount', amount);
      });
    }

    var itemName = '';
    var checked = info.querySelector('.variant-picker input:checked');
    if (checked && checked.dataset && checked.dataset.alvaLabel) {
      var value = checked.dataset.alvaLabel.split('(')[0].trim();
      var qty = value.match(/^\d+/);
      if (/set|[- ]pc|piece/i.test(value) && qty) itemName = qty[0] + '-Piece Set';
      else if (/inch/i.test(value)) itemName = value.replace(/-inch/i,'-inch Pan');
    }

    if (!itemName) {
      var currentSet = info.querySelector('.alva-connected [aria-current="page"] .alva-connected__size');
      var setName = currentSet && (currentSet.textContent || '').trim();
      var setQuantity = setName && setName.match(/^(\d+)[- ](?:piece|pc)\b/i);
      if (setQuantity) itemName = setQuantity[1] + '-Piece Set';
    }

    var compare = alvaCleanPrice(info.querySelector('.alva-price-row__compare'));
    if (canLabel && !btn.disabled && btn.getAttribute('aria-busy') !== 'true') {
      var atcLabel = 'Add to cart';
      var labelKey = price + '|' + atcLabel;
      if (target.hasAttribute('data-alva-atc-label')) {
        if (target.dataset.alvaPriceKey !== labelKey) {
          target.replaceChildren(document.createTextNode(atcLabel + ' · '));
          var currentPrice = document.createElement('span');
          currentPrice.className = 'alva-atc-current';
          currentPrice.textContent = price;
          target.appendChild(currentPrice);
          target.dataset.alvaPriceKey = labelKey;
        }
      } else {
        var full = atcLabel + ' · ' + price;
        if (target.textContent !== full) target.textContent = full;
      }
    }
    var stickyBar = root.querySelector('product-sticky-bar');
    var previous = window.alvaPurchaseState;
    var state = { price:price, cents:cents, compare:compare, variant:row && row.dataset.alvaPriceVariant, withLid:withLid, itemName:itemName, available:!btn.disabled, button:btn, stickyBar:stickyBar };
    window.alvaPurchaseState = state;
    if (!previous || Object.keys(state).some(function(key){ return state[key] !== previous[key]; })) {
      document.dispatchEvent(new CustomEvent('alva:pdp:prices', {detail:state}));
    }

    var sticky = document.querySelector('.product-sticky-bar .buy-buttons button');
    if (!sticky) return;
    var stickyTarget = sticky.querySelector('span') || sticky;
    var stickyBase = (stickyTarget.textContent || '').trim();
    if (!/^add\b/i.test(stickyBase)) return;
    var stickyLabel = stickyBase.split('·')[0].trim() + ' · ' + price;
    if (stickyTarget.dataset.alvaPriceKey !== stickyLabel) {
      var action = document.createElement('span');
      action.className = 'alva-sticky-action';
      action.textContent = stickyBase.split('·')[0].trim();
      var separator = document.createElement('span');
      separator.className = 'alva-sticky-separator';
      separator.textContent = ' · ';
      var amount = document.createElement('span');
      amount.className = 'alva-atc-current';
      amount.textContent = price;
      stickyTarget.replaceChildren(action, separator, amount);
      stickyTarget.dataset.alvaPriceKey = stickyLabel;
    }
  }

  window.alvaSyncPurchasePrices = setAtc;

  function fillDots(){
    document.querySelectorAll('.product-info .variant-picker .color-swatch:not(.alva-dot-solid)').forEach(function(swatch){
      var value = getComputedStyle(swatch).getPropertyValue('--swatch-background');
      var match = value && value.match(/url\(["']?([^"')]+)/);
      if (!match) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function(){
        try {
          var canvas = document.createElement('canvas');
          canvas.width = canvas.height = 3;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img,img.width*.4,img.height*.4,img.width*.2,img.height*.2,0,0,3,3);
          var data = ctx.getImageData(0,0,3,3).data, r=0,g=0,b=0,n=0;
          for (var i=0;i<data.length;i+=4) if (data[i+3] > 200) { r+=data[i]; g+=data[i+1]; b+=data[i+2]; n++; }
          if (!n) return;
          swatch.style.setProperty('--alva-dot','rgb(' + Math.round(r/n) + ',' + Math.round(g/n) + ',' + Math.round(b/n) + ')');
          swatch.classList.add('alva-dot-solid');
        } catch(e) {}
      };
      img.src = match[1];
    });
  }

  if (HAS_LID) {
  window.__alvaLidWant = window.__alvaLidWant || false;

  function lidVariantId(){
    var source = document.querySelector('[data-alva-lid-toggle]');
    return source ? source.dataset.alvaLidToggle : null;
  }


  function lidVariantIds(){
    var source = document.querySelector('[data-alva-lid-toggle]');
    if (!source) return [];
    try {
      var ids = source.dataset.alvaLidIds ? JSON.parse(source.dataset.alvaLidIds) : [source.dataset.alvaLidToggle];
      if (!Array.isArray(ids) || !ids.length || ids.length > 3) return [];
      ids = ids.map(Number);
      if (ids.some(function(id){ return !Number.isSafeInteger(id) || id <= 0; })) return [];
      return Array.from(new Set(ids));
    } catch(error) { return []; }
  }

  function paintLid(){
    var wrap = document.getElementById('AlvaLidPicker');
    if (!wrap) return;
    var on = !!window.__alvaLidWant;
    wrap.querySelectorAll('[data-alva-lid-choice]').forEach(function(button){
      var selected = (button.dataset.alvaLidChoice === 'with') === on;
      button.classList.toggle('is-selected',selected);
      if (button.getAttribute('role') === 'checkbox') button.setAttribute('aria-checked',String(selected));
      else button.setAttribute('aria-pressed',String(selected));
    });
    var label = wrap.querySelector('[data-alva-lid-selection-label]');
    if (label) label.textContent = on ? (label.dataset.labelOn || 'Matching lid added') : (label.dataset.labelOff || 'Add matching lid');
  }

  function buildLid(){
    if (!document.querySelector('.alva-lid-addon')) window.__alvaLidWant = false;
    paintLid();
  }

  document.addEventListener('click',function(event){
    var button = event.target.closest('#AlvaLidPicker [data-alva-lid-choice]');
    if (!button) return;
    window.__alvaLidWant = button.classList.contains('alva-lid-option') ? !window.__alvaLidWant : button.dataset.alvaLidChoice === 'with';
    var wrap = button.closest('#AlvaLidPicker');
    var error = wrap.querySelector('[data-alva-lid-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    paintLid(); setAtc();
  });
  }

  function refresh(){
    if (HAS_LID) buildLid();
    setAtc();
    fillDots();
  }

  var frame = false;
  function schedule(){
    if (frame) return;
    frame = true;
    requestAnimationFrame(function(){ frame = false; refresh(); });
  }

  function start(){
    refresh();
    /* alva-gallery emits one scoped event after Prestige replaces PDP blocks. */
    document.addEventListener('alva:pdp:render',function(event){
      if (!event.detail || !event.detail.components || event.detail.components.indexOf('purchase') !== -1 || event.detail.components.indexOf('content') !== -1) schedule();
    });
    window.addEventListener('pageshow',schedule);
    document.addEventListener('shopify:section:load',schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();

  if (!window.__alvaAccSingleFast) {
    window.__alvaAccSingleFast = true;
    document.addEventListener('toggle',function(event){
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      if (!details.closest('accordion-disclosure') || !details.closest('.product-info')) return;
      document.querySelectorAll('.product-info accordion-disclosure details[open]').forEach(function(other){
        if (other !== details) other.removeAttribute('open');
      });
    },true);
  }

  if (HAS_LID && !window.__alvaAtomicLidFast) {
    window.__alvaAtomicLidFast = true;
    var lidAddBusy = false;
    document.addEventListener('submit',async function(event){
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!form.closest('.product-info') && !form.closest('.product-sticky-bar')) return;
      if (form.dataset.alvaSelectionPending || form.dataset.alvaSelectionError) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!lidVariantId()) window.__alvaLidWant = false;
      if (window.AlvaMaestroGift?.active() && document.querySelector('.alva-maestro-gift')) return;
      if (!window.__alvaLidWant) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var submitter = event.submitter;
      if (submitter && submitter.getAttribute('aria-busy') === 'true') return;
      if (!form.checkValidity()) { form.reportValidity(); return; }

      var data = new FormData(form);
      var panId = parseInt(data.get('id'),10);
      if (!panId) {
        var selected = document.querySelector('.product-info .variant-picker select[name="id"]');
        if (selected) panId = parseInt(selected.value,10);
      }
      if (!panId) {
        var variantJson = document.querySelector('.product-info .variant-picker script[data-variant]');
        try { panId = variantJson ? parseInt(JSON.parse(variantJson.textContent).id,10) : 0; } catch(e) {}
      }
      var lidIds = lidVariantIds();
      var picker = document.getElementById('AlvaLidPicker');
      var errorNode = picker && picker.querySelector('[data-alva-lid-error]');
      function showError(message){ if (errorNode) { errorNode.textContent = message; errorNode.hidden = false; } }
      var lidSource = document.querySelector('[data-alva-lid-toggle]');
      var matchedPanId = lidSource ? parseInt(lidSource.dataset.alvaPanVariant,10) : 0;
      if (!panId || !lidIds.length || matchedPanId !== panId) { showError('We could not match this lid to your selected pan. Please reselect the size and try again.'); return; }

      var quantity = parseInt(data.get('quantity') || '1',10); if (!quantity || quantity < 1) quantity = 1;
      var panItem = { id: panId, quantity: quantity };
      var properties = {};
      data.forEach(function(value,key){ var m = key.match(/^properties\[(.+)\]$/); if (m && value !== '') properties[m[1]] = value; });
      if (Object.keys(properties).length) panItem.properties = properties;
      var sellingPlan = data.get('selling_plan'); if (sellingPlan) panItem.selling_plan = parseInt(sellingPlan,10);

      if (lidAddBusy || window.__alvaCartMutationPending || window.AlvaLidCart?.busy || window.AlvaMaestroGift?.busy) { showError('Your cart is updating. Please wait.'); return; }
      lidAddBusy = true;
      var buttons = Array.prototype.filter.call(form.elements || [],function(control){ return control.type === 'submit'; });
      buttons.forEach(function(button){ button.setAttribute('aria-busy','true'); });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start',{bubbles:true}));

      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:sections}}));

      try {
        var response = await fetch(root + 'cart/add.js',{
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({items:[panItem].concat(lidIds.map(function(id){ return {id:id,quantity:quantity}; })),sections:sections.join(','),sections_url:root + 'variants/' + panId})
        });
        var json = await response.json();
        if (!response.ok) {
          var apiError = json.description || json.message || 'We could not add the cookware and matching lids. Please try again.';
          form.dispatchEvent(new CustomEvent('cart:error',{bubbles:true,detail:{error:apiError}}));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          showError(apiError); return;
        }
        var added = json.items || [];
        var ids = added.map(function(item){ return parseInt(item.variant_id || item.id,10); });
        if (ids.indexOf(panId) === -1 || lidIds.some(function(id){ return ids.indexOf(id) === -1; })) throw new Error('both-items');
        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') { window.location.href = root + 'cart'; return; }

        var cartResponse = await fetch(root + 'cart.js');
        var cart = await cartResponse.json();
        cart.sections = json.sections || {};
        form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:added,cart:cart,onSuccessDo:data.get('on_success')}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:data.get('on_success'),cart:cart}}));
      } catch(error) {
        var message = error && error.message === 'both-items' ? 'We could not confirm all selected items. Please check your cart before trying again.' : 'We could not confirm your cart update. Please check your cart before trying again.';
        form.dispatchEvent(new CustomEvent('cart:error',{bubbles:true,detail:{error:message}}));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        showError(message);
      } finally {
        lidAddBusy = false;
        buttons.forEach(function(button){ button.removeAttribute('aria-busy'); });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end',{bubbles:true}));
      }
    },true);
  }
})();

